module.exports = {
  findPwd: {
    find: '找回密码',
    userName: '手机号或邮箱',
    error_userName_1: '请输入手机号或邮箱',
    error_userName_2: '该号码未绑定任何投影仪账号',
    error_userName_3: '该邮箱未绑定任何投影仪账号',
    get_code: '发送验证码',
    get_code_tip: '点击发送验证码',
    get_code_tip_re: '秒后重新发送',
    code: '验证码',
    error_code_1: '请输入验证码',
    error_code_2: '获取验证码次数已达今日上限，请明天再试！',
    error_code_3: '验证码错误',
    error_code_4: '验证码已经发送，10分钟内有效',
    error_code_5: '验证码获取频率频繁，请稍后再试',
    error_phone: '请输入正确账号',
    next: '下一步',
    input_password: '输入新密码',
    repeat_new_password: '确认新密码',
    new_password_error: '两次密码不一致',
    submit_new_password: '提交',
    success_relogin: '密码重置成功，请重新登录',
    button_relogin: '重新登录',
    password_set: '8-20位字母及数字组合密码',
    account_info: '账号信息',
    current_account: '当前绑定账号',
    change_password: '修改密码',
    phone_find: '通过绑定手机或邮箱找回账号密码',
    not_bind_starryHub: '未绑定任何投影仪账号',
    expired: '已过期',
    account_type: '请选择账号类型',
    starryHub_account: '投影仪账号',
    czur_cloud_account: '成者云账号'
  },
  tips: {
    timeout: '請求超時!',
    internalError: '服務器內部異常！',
    networkError: '網絡連接異常!',
    connectError: '連接出錯(',
    errorStatus: '請求錯誤(400)'
  },
  index: {
    loginText: '成者雲',
    accountNumber: '成者賬號/會議號',
    password: '密碼',
    forgetPwd: '忘記密碼',
    register: '新用戶註冊',
    errorTip: '用戶名/密碼錯誤',
    selectFunction: '請選擇對應功能',
    unactivated: '用戶未激活',
    notebook: '筆記本',
    mobileTip: '該網頁是專為PC用戶設計開發的雲服務',
    youCan: '您可以：',
    mobileTextOne: '手機用戶請下載“成者CZUR”APP',
    mobileTextTwo: '或使用PC瀏覽該網頁',
    downloadApp: '下載APP',
    countryError: '該賬號為非本地區註冊，是否跳轉至註冊地區獲取相關服務？',
    countryGo: '確定'
  },
  list: {
    noFile: '還沒有文件',
    time: '時間',
    category: '分類',
    accountCenter: '賬戶中心',
    logOut: '退出登錄',
    thisday: '當日',
    items: '項',
    total: '共',
    feedback: '建議反饋',
    used: '已使用',
    back: '返回',
    loading: '加載中...',
    loaded: '已加載完畢',
    feedbackPlaceholder: '請輸入反饋信息（300字以內）',
    submit: '提交',
    cancel: '取消',
    feedbackSuccess: '意見反饋成功！',
    label: '標簽',
    empty: '空'
  },
  player: {
    flatSinglePage: '平整單張',
    curvePage: '左右曲面',
    color: '彩色',
    grayscale: '灰度',
    bw: '黑白',
    pattern: '證件底紋',
    autoEnhance: '自動優化',
    copyToClipboard: '已復制至剪切板',
    noOcrResult: '無識別結果',
    ocrTip: '請在成者CZUR APP裏進行手寫體識別'
  },
  operation: {
    selected: '已選',
    selectAllLoaded: '全選已加載',
    deselectAll: '取消選擇',
    moveFiles: '移動',
    share: '分享',
    exportPDF: '導出PDF',
    download: '下載',
    delete: '删除',
    moveToFolder: '移動至文件夾',
    rename: '重命名',
    confirm: '確認',
    msg: '提示',
    moveFilesSuccess: '文件移動成功',
    floderName: '請輸入文件夾名稱',
    shareTimeLimit: '分享鏈接期限',
    hours: '小時',
    days: '天',
    createLink: '創建鏈接',
    shareLink: '分享鏈接',
    password: '密碼',
    copy: '復制',
    createPDF: '創建PDF',
    pdfName: '請輸入PDF名稱',
    pdfSet: 'PDF設置',
    pdfSize: 'PDF尺寸',
    autoAdjustment: '自適應',
    pdfDirection: 'PDF方向',
    vertical: '縱向',
    horizontal: '橫向',
    pdfQuality: 'PDF質量',
    standard: '標準',
    maximum: '最優',
    pdfCreated: '創建PDF成功',
    done: '完成'
  },
  share: {
    shareLink: '成者雲ET分享鏈接：',
    expire: ' 過期時間：',
    shared: '的分享',
    enterPassword: '请输入提取码',
    wrongPassword: '提取码错误',
    fileExpired: '文件已过期',
    fileDelete: '文件已删除',
    package: '打包中...',
    shareNotebookLink: '成者雲筆記本分享鏈接：'
  },
  device: {
    deviceList: '設備列表',
    noDevice: '暫無設備',
    apply: '使用',
    using: '使用中',
    bindDeviceTips: '請使用“成者CZUR”App，掃描設備底座下的二維碼，進行綁定添加ET設備',
    gotIt: '知道了',
    isUsingDevice: '正在使用此設備',
    unbindDevice: '解綁設備',
    searchAccount: '搜索成者賬號',
    searchMember: '搜索成員',
    transferAdministrator: '轉讓管理員',
    deleteMember: '刪除成員',
    shareDevice: '開放此設備',
    shareDeviceTips: '開放設備後，其它用戶可以通過掃描ET底座的二維碼來使用此設備，但妳仍是管理員。',
    noMember: '還沒有其他成員',
    unbindDeviceTips: '解綁後，所有成員將無法使用此設備，成者雲賬號和存儲的資料會保留。重啟ET設備後生效',
    unbind: '解綁',
    noAccount: '賬號不存在',
    addMember: '添加成員',
    administrator: '管理員',
    added: '已添加',
    cancelTransfer: '取消轉讓',
    conformTransfer: '確認轉讓',
    ifTransferadministrator: '確認將管理員轉讓給',
    cancelDelete: '取消刪除',
    confirmDelete: '確認刪除',
    ifDeleteMember: '確認刪除成員',
    and: '等',
    others: '人',
    needFirmwareUpgrade: '需固件升级',
    statement: '聲明',
    upgradeTest: '由於雲服務升級改造，您的ET需升級固件',
    upgradeTestOne: '1.將ET開機，並通過USB連接電腦；',
    upgradeTestTwo: '2.安裝並打開CZUR Scanner 軟件；',
    upgradeTestThree: '3.進入軟件的系統設置-固件版本-點擊升級，按軟件提示完成升級；',
    upgradeTestFour: '4.斷開USB線進入Wi- Fi模式，確定ET聯網成功，刷新App即可使用。'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/zh_TW.js